import { Box, Typography, styled } from "@mui/material";

import React from "react";

function InstallingInstructions({ steps }) {
  return (
    <Box mt={1}>
      {steps.map((step) => (
        <TypographyStyle color="text.main" variant="subtitle1" dir="rtl">
          {step}
        </TypographyStyle>
      ))}
    </Box>
  );
}

const TypographyStyle = styled(Typography)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",

  svg: {
    width: "20px",
    height: "20px",
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
}));

export default InstallingInstructions;
